import styles from "./style.module.scss";
import { Col, ColProps } from "reactstrap";
import cx from "classnames";

interface AmountItem {
  amount: string;
  amountTitle: string;
}

type DashboardCardProps = {
  cardTitle: string,
  cardType: "deudores" | "acredores" | "cuentas" | "noticias"
  amounts?: AmountItem[],
  children?: React.ReactNode;
} & ColProps;;

const DashboardCard = (props: DashboardCardProps) => {
  const { cardTitle, cardType, amounts, children, ...rest } = props;

  const listElements = (): JSX.Element => {
    return (
      <ul className={styles.commonList}>
        {
          amounts?.map((e) => {
            return (
              <li className={styles.amountItem}>
                <div className={styles.amount}>
                  {e.amount}
                </div>
                <div className={styles.amountTitle}>
                  {e.amountTitle}
                </div>
              </li>
            )
          })
        }
      </ul>
    )
  }

  return (
    <Col
      md="3"
      sm="6"
      {...rest}>
      <div className={cx(
        [
          styles.dashboardCard,
          styles[`${cardType}Card`]
        ])}
      >
        <h2 className={styles.cardTitle}>
          {cardTitle}
        </h2>
        <div className={styles.blockContent}>
          {listElements()}
          {children}
        </div>
      </div>
    </Col >
  )
}

export default DashboardCard;